import { isObject } from "lodash";
import SocketWorker from "./SocketWorker";

/** Placeholder até o SocketWorker conectar — evita `socket.on is not a function` com `{}`. */
export const SOCKET_STUB = {
  __socketStub: true,
  on() {},
  off() {},
  emit() {}
};

export function isSocketReady(socket) {
  return Boolean(
    socket && typeof socket.on === "function" && !socket.__socketStub
  );
}

export function socketConnection(params) {
  let userId = "";
  let companyId = "";
  if (isObject(params)){
    companyId = params?.user?.companyId
    userId = params?.user?.id
  }
 
  return SocketWorker(companyId,userId)
}